/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface OrderCustomerControllerGetReplaceProductImpact$Params {
  id: number;

/**
 * product_id del prodotto da sostituire
 */
  old_product_id?: number;

/**
 * agreement_product_id del prodotto da sostituire
 */
  old_agreement_product_id?: number;

/**
 * agreement_product_id del nuovo prodotto (per defaults)
 */
  new_agreement_product_id?: number;

/**
 * product_id del nuovo prodotto base (per defaults)
 */
  new_product_id?: number;
}

export function orderCustomerControllerGetReplaceProductImpact(http: HttpClient, rootUrl: string, params: OrderCustomerControllerGetReplaceProductImpact$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, orderCustomerControllerGetReplaceProductImpact.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('old_product_id', params.old_product_id, {});
    rb.query('old_agreement_product_id', params.old_agreement_product_id, {});
    rb.query('new_agreement_product_id', params.new_agreement_product_id, {});
    rb.query('new_product_id', params.new_product_id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

orderCustomerControllerGetReplaceProductImpact.PATH = '/order-customer/{id}/replace-product/impact';
